module.exports = __webpack_public_path__ + "static/media/21ECLAC24.07251a54.jpg";